export const socialsLinks = {
    linkedin: "https://www.linkedin.com/company/udataua",
    instagram: "",
    goodFirm: "",
    upToWork: "https://www.upwork.com/agencies/udata/",
    telegram: "",
    clutch: "https://clutch.co/profile/udata-1",
    staffPower: "https://staffpower.pl/"
}
// [
//     { name: "LinkedIn", href: "https://www.linkedin.com/company/udataua", icon: <Linkedn /> },
//     { name: "Instagram", href: "", icon: <Instagram /> },
//     { name: "GoodFirm", href: "", icon: <GoodFirm /> },
//     { name: "UpToWork", href: "https://www.upwork.com/agencies/udata/", icon: <UpToWork /> },
//     { name: "Telegram", href: "", icon: <Telegram /> },
//     { name: "Clutch", href: "https://clutch.co/profile/udata-1", icon: <Clutch /> },
// ];